export default __webpack_public_path__ + "static/media/8.5de71c23.png";